export function snakeToKebabCase(str: string): string {
    return str.toLocaleLowerCase().split('_').join('-');
}
